import { SearchBarLayout, SearchFormLayout } from './searchBar.layout'
import { SearchBarProps, SearchFormProps } from './searchBar.state'


export const SearchBar = (props: SearchBarProps) => {
  return SearchBarLayout(props);
}

export const SearchForm = (props: SearchFormProps) => {
  return SearchFormLayout(props)
}